<template>
    <v-bottom-sheet v-model="shows" fullscreen persistent @input="emit">
        <template #activator="{ attrs, on }">
            <slot name="activator" v-bind="{ attrs, on }" />
        </template>
        <v-card flat tile class="bottom-sheet__card">
            <v-card-title>
                <span> {{ title }} </span>
                <v-btn small text fab tile absolute right @click="exit">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider />
            <v-layout column justify-center class="bottom-sheet__card__body" v-bind="{ style: style_body }">
                <slot />
            </v-layout>
            <template v-if="!hideFoot">
                <v-divider />
                <v-layout justify-center class="bottom-sheet__card__foot">
                    <slot name="foot" />
                </v-layout>
            </template>
        </v-card>
    </v-bottom-sheet>
</template>

<script>
export default {
    props: {
        /** @type {import('vue').PropType<boolean>} */
        value: { type: Boolean, default: false }, // shows

        /** @type {import('vue').PropType<boolean>} */
        loading: { type: Boolean, default: false },

        /** @type {import('vue').PropType<boolean>} */
        hideFoot: { type: Boolean, default: false },

        /** @type {import('vue').PropType<string>} */
        title: { type: String, default: null },
    },
    data: () => ({
        shows: false,
    }),
    computed: {
        style_body() {
            return {
                flexBasis: `calc(100vh - 58px - 1px${this.hideFoot ? "" : " - 1px - 68px"})`,
            };
        },
    },
    methods: {
        sync() {
            this.shows = this.value;
        },
        emit() {
            this.$emit("input", this.shows);
        },
        exit() {
            this.shows = false;
            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.bottom-sheet {
    &__card {
        display: flex;
        flex-direction: column;

        &__body {
            flex-grow: 0;
            flex-shrink: 0;
            overflow: hidden;
            position: relative;
        }

        &__foot {
            flex-grow: 0;
            flex-shrink: 1;
            flex-basis: auto;
            padding: 16px;
            gap: 8px;
        }
    }
}
</style>
